import _upperFirst from 'lodash/upperFirst';

import { COURSE_PLATFORMS_TEXT } from 'constants/common';

import { idxMap } from 'helpers/styleMapIdx';

export const getCourseSubtitle = (platform: any) => {
  if (!platform) {
    return '';
  }

  return idxMap(COURSE_PLATFORMS_TEXT as Record<string, string>, platform);
};

export const getCourseType = (type: any) => {
  if (!type) {
    return '';
  }

  return String(type)
    .split('_')
    .map((word) => _upperFirst(word.toLowerCase()))
    .join(' ');
};
